import { useMemo, useRef, useState } from 'react';

import { Tooltip } from '@atom/mui';
import { WorkOrder } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

const styles = {
  container: {
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
};

interface Props {
  workOrder: WorkOrder;
}

const WeekViewEventTitle = ({ workOrder }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hovering, setHovering] = useState(false);

  const overflowing: boolean = useMemo(() => {
    if (isNilOrEmpty(containerRef.current)) {
      return false;
    }
    const { offsetWidth, scrollWidth } = containerRef.current;
    return offsetWidth < scrollWidth;
  }, [hovering]);

  return (
    <div
      ref={containerRef}
      style={styles.container}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      {overflowing ? (
        <Tooltip title={workOrder.name}>
          <span>{workOrder.name}</span>
        </Tooltip>
      ) : (
        workOrder.name
      )}
    </div>
  );
};

export default WeekViewEventTitle;
